import { AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <div
      className="border-t border-white/10 bg-[#0A0A0C] py-3 px-6 flex items-center gap-3"
      data-testid="disclaimer-banner"
    >
      <AlertTriangle className="w-4 h-4 text-yellow-400 flex-shrink-0" strokeWidth={2} />
      <p className="font-mono text-[10px] tracking-wider text-zinc-400 leading-relaxed">
        EDUCATIONAL ANALYSIS ONLY. Ennis is an AI experiment — outputs are not financial advice,
        not a recommendation to buy or sell, and may be wrong. Markets carry risk of loss. Do your
        own research and consult a licensed advisor before trading.
      </p>
    </div>
  );
}
